module.exports = __webpack_public_path__ + "img/delete.b4644877.svg";